module.exports = __webpack_public_path__ + "img/DZ.4450a753.svg";